/**
 * FUNKLESS Collection Filters - JavaScript
 * Handles filter interactions, accordion toggles, mobile drawer, and form submission
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFunklessFilters);
  } else {
    initFunklessFilters();
  }

  function initFunklessFilters() {
    const sections = document.querySelectorAll('.funkless-filters-section');
    
    sections.forEach(section => {
      new FunklessFilters(section);
    });
  }

  class FunklessFilters {
    constructor(container) {
      this.container = container;
      this.sectionId = container.dataset.sectionId;
      this.sidebar = container.querySelector('.funkless-sidebar');
      this.mobileToggle = container.querySelector('.funkless-mobile-toggle');
      this.closeBtn = container.querySelector('.funkless-close-btn');
      this.overlay = container.querySelector('.funkless-sidebar-overlay');
      this.filterForm = container.querySelector('[data-funkless-filter-form]');
      this.filterToggles = container.querySelectorAll('.funkless-filter-toggle');
      this.filterInputs = container.querySelectorAll('[data-funkless-filter-input]');
      this.clearAllBtn = container.querySelector('[data-funkless-clear-all]');
      this.loadingIndicator = container.querySelector('.funkless-loading');

      this.bindEvents();
    }

    bindEvents() {
      // Mobile toggle
      if (this.mobileToggle) {
        this.mobileToggle.addEventListener('click', () => this.openSidebar());
      }

      // Close button
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.closeSidebar());
      }

      // Overlay click
      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.closeSidebar());
      }

      // Escape key to close
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.sidebar?.classList.contains('is-open')) {
          this.closeSidebar();
        }
      });

      // Accordion toggles
      this.filterToggles.forEach(toggle => {
        toggle.addEventListener('click', () => this.toggleAccordion(toggle));
      });

      // Filter input changes
      this.filterInputs.forEach(input => {
        input.addEventListener('change', () => this.handleFilterChange());
      });

      // Clear all button (if using link, let it navigate naturally)
      // If you want AJAX behavior, uncomment below:
      // if (this.clearAllBtn) {
      //   this.clearAllBtn.addEventListener('click', (e) => {
      //     e.preventDefault();
      //     this.clearAllFilters();
      //   });
      // }

      // Handle browser back/forward
      window.addEventListener('popstate', () => {
        // Reload page to reflect URL state
        window.location.reload();
      });
    }

    openSidebar() {
      if (!this.sidebar) return;
      
      this.sidebar.classList.add('is-open');
      this.overlay?.classList.add('is-visible');
      document.body.classList.add('funkless-sidebar-open');
      
      if (this.mobileToggle) {
        this.mobileToggle.setAttribute('aria-expanded', 'true');
      }

      // Focus first focusable element in sidebar
      const firstFocusable = this.sidebar.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (firstFocusable) {
        setTimeout(() => firstFocusable.focus(), 100);
      }
    }

    closeSidebar() {
      if (!this.sidebar) return;
      
      this.sidebar.classList.remove('is-open');
      this.overlay?.classList.remove('is-visible');
      document.body.classList.remove('funkless-sidebar-open');
      
      if (this.mobileToggle) {
        this.mobileToggle.setAttribute('aria-expanded', 'false');
        this.mobileToggle.focus();
      }
    }

    toggleAccordion(toggle) {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      const contentId = toggle.getAttribute('aria-controls');
      const content = document.getElementById(contentId);

      if (!content) return;

      if (expanded) {
        // Collapse
        toggle.setAttribute('aria-expanded', 'false');
        content.classList.add('is-collapsed');
        content.setAttribute('hidden', '');
      } else {
        // Expand
        toggle.setAttribute('aria-expanded', 'true');
        content.classList.remove('is-collapsed');
        content.removeAttribute('hidden');
      }
    }

    handleFilterChange() {
      // Show loading state
      this.showLoading();

      // Build URL from form data
      const formData = new FormData(this.filterForm);
      const params = new URLSearchParams();

      // Get current URL's pathname
      const currentPath = window.location.pathname;

      // Process form data
      for (const [key, value] of formData.entries()) {
        if (value) {
          params.append(key, value);
        }
      }

      // Navigate to new URL
      const newUrl = `${currentPath}?${params.toString()}`;
      
      // Use fetch to get new page content (for smoother UX)
      // Or just navigate directly
      window.location.href = newUrl;
    }

    clearAllFilters() {
      this.showLoading();
      
      // Get sort_by value to preserve it
      const sortByInput = this.filterForm?.querySelector('input[name="sort_by"]');
      const sortBy = sortByInput?.value || '';
      
      const currentPath = window.location.pathname;
      const newUrl = sortBy ? `${currentPath}?sort_by=${sortBy}` : currentPath;
      
      window.location.href = newUrl;
    }

    showLoading() {
      if (this.loadingIndicator) {
        this.loadingIndicator.classList.add('is-loading');
        this.loadingIndicator.setAttribute('aria-busy', 'true');
      }
      
      // Add loading class to container
      this.container.classList.add('is-loading');
    }

    hideLoading() {
      if (this.loadingIndicator) {
        this.loadingIndicator.classList.remove('is-loading');
        this.loadingIndicator.setAttribute('aria-busy', 'false');
      }
      
      this.container.classList.remove('is-loading');
    }
  }

  // Expose to global scope if needed
  window.FunklessFilters = FunklessFilters;

})();
